import { type Metric } from '../vessel_data'

export enum EpmMetric {
  generatorFuelConsumption = 'generatorFuelConsumption',
  generatorPortFuelConsumption = 'generatorPortFuelConsumption',
  generatorStbdFuelConsumption = 'generatorStbdFuelConsumption',
  generatorCntrFuelConsumption = 'generatorCntrFuelConsumption',

  generatorPortPower = 'generatorPortPower',
  generatorStbdPower = 'generatorStbdPower',
  generatorCntrPower = 'generatorCntrPower',

  bmsChargeState1 = 'bmsChargeState1',
  bmsChargeState2 = 'bmsChargeState2',

  energyPriceC32 = 'energyPriceC32',
  energyPriceC18PS = 'energyPriceC18PS',
  energyPriceC18SB = 'energyPriceC18SB',
  energyPriceShore = 'energyPriceShore',
  energyPriceBattery = 'energyPriceBattery'
}
export type EpmMetricName = keyof typeof EpmMetric

export type EpmMetrics = Record<EpmMetricName, Metric>

export const allEpmMetricNames: EpmMetricName[] = Object.values(EpmMetric)
